module.exports = __webpack_public_path__ + "img/联系我们.fa4971a1.jpg";